import { CentraJS } from "@frend-digital/centra-js-client";
import type { BaseSelectionResponse } from "@frend-digital/centra-types/selection";

export type PromoVariables = { code: string; remove: boolean };

const setPromo = async <FormattedSelection>({
  api,
  customerToken,
  formatter,
  variables,
}: {
  variables: PromoVariables;
  customerToken: string;
  api: string;
  formatter: (selection: BaseSelectionResponse) => FormattedSelection;
}) => {
  CentraJS.suspend();

  const res = await fetch(`${api}/vouchers`, {
    method: !variables.remove ? "POST" : "DELETE",
    headers: { "API-token": customerToken || "" },
    body: JSON.stringify({
      voucher: variables.code,
    }),
  });

  CentraJS.resume();

  if (!res.ok) {
    throw res;
  }
  const response = await res.json();
  return formatter(response);
};

export default setPromo;
